import { CertificateStatus } from "@/utils/api-client/models/certificate/CertificateStatus";
import { ApiClient } from "./clients";

export interface CertificateSyncItem {
  thumbprint: string;
  ownerName: string;
  subjectName: string;
  issuerName: string;
  inn?: string;
  validFrom?: string;
  validTo?: string;
  privateKeyValidTo?: string;
}

export interface CertificateSyncResult {
  statuses: CertificateStatus[];
}

export class CertificateManager {
  constructor(private readonly apiClient: ApiClient) {}

  sync(certificates: CertificateSyncItem[]): Promise<CertificateSyncResult> {
    return this.apiClient.post("/sync", { certificates });
  }
}
